import { Injectable, inject, Signal } from '@angular/core';
import {
  CalendarInfoTask,
  CreateTaskRequest,
  Task,
  UpdateTaskRequest,
} from '@lyceo/shared/plan/util-models';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { TaskActions, TaskModalActions, TaskPageActions } from './task.actions';
import * as TaskSelectors from './task.selectors';

@Injectable({
  providedIn: 'root',
})
export class TaskFacade {
  private readonly store: Store = inject(Store);

  public readonly error: Signal<string | null> = this.store.selectSignal(
    TaskSelectors.selectTaskError,
  );
  public readonly loading: Signal<boolean> = this.store.selectSignal(
    TaskSelectors.selectTaskLoading,
  );
  public readonly loadedList: Signal<boolean> = this.store.selectSignal(
    TaskSelectors.selectTaskLoadedList,
  );
  public readonly fetchByDateSorted: Signal<Task[]> = this.store.selectSignal(
    TaskSelectors.selectTasksByDateSorted,
  );
  public readonly allTodoTasks: Signal<Task[]> = this.store.selectSignal(
    TaskSelectors.selectAllTodoTasks,
  );
  public readonly reflectionId: Signal<string | undefined> =
    this.store.selectSignal(TaskSelectors.selectReflectionId);
  public readonly allCalendarInfoTasks: Signal<CalendarInfoTask[]> =
    this.store.selectSignal(TaskSelectors.selectAllCalendarInfoTasks);
  public readonly reflectionTask: Signal<Task | undefined> =
    this.store.selectSignal(TaskSelectors.selectReflectionTask);
  public readonly selectedTasks: Signal<Task | undefined> =
    this.store.selectSignal(TaskSelectors.selectSelectedTask);
  public readonly selectedSubtasks: Signal<Task[]> = this.store.selectSignal(
    TaskSelectors.selectSelectedSubtasks,
  );
  public readonly taskModalSubtaskLoaded: Signal<boolean> =
    this.store.selectSignal(TaskSelectors.selectTaskModalSubtaskLoaded);
  public readonly moveLoading: Signal<boolean> = this.store.selectSignal(
    TaskSelectors.selectMoveLoading,
  );

  public sortedTasksByDay: (day: Date) => Signal<Task[]> = (day: Date) =>
    this.store.selectSignal(TaskSelectors.selectSortedTasksByDay(day));

  public openAccordion$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  public pageInit(): void {
    this.store.dispatch(TaskPageActions.init());
  }

  public modalInit(): void {
    this.store.dispatch(TaskModalActions.init());
  }

  public create(request: CreateTaskRequest): void {
    this.store.dispatch(TaskActions.create({ request }));
  }

  public update(request: UpdateTaskRequest): void {
    this.store.dispatch(TaskActions.update({ request }));
  }

  public delete(id: string): void {
    this.store.dispatch(TaskActions.delete({ id }));
  }

  public todoTaskClicked(task: Task): void {
    this.store.dispatch(TaskPageActions.todoTaskClicked({ task }));
  }
}
